import i18nFactory from '@yandex-int/i18n';
import { PopupDirection } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import {
    ProductsListCellItem,
    ProductsPageStates
} from '../../typings/products';
import { ButtonDecorator } from '../ButtonDecorator/ButtonDecorator';
import { DirectFormInput } from '../DirectFormInput/DirectFormInput';
import { EditableCell } from '../EditableCell/EditableCell';
import { InputFieldType } from '../InputField/InputField';
import { PopupDecorator } from '../PopupDecorator/PopupDecorator';

import './ProductDescriptionCell.css';
import * as keyset from './ProductDescriptionCell.i18n';

const BLOCK = 'product-description-cell';
const DIRECTIONS: PopupDirection[] = ['top-center', 'bottom-center'];

const i18n = i18nFactory(keyset);

export interface ProductDescriptionCellProps {
    product: ProductsListCellItem;
    pageStatus: ProductsPageStates;
    onSaveProductDescription: (product: ProductsListCellItem) => void;
    onChangeProductDescription: (product: ProductsListCellItem) => void;
    isGridScrolling: boolean;
    access: boolean;
}

export class ProductDescriptionCell extends React.Component<
    ProductDescriptionCellProps
> {
    render() {
        return <div className={Bem.cls(BLOCK)}>{this.renderBody()}</div>;
    }

    public componentDidUpdate() {
        if (this.props.product.isEdited && this.props.isGridScrolling) {
            this.toggleForm();
        }
    }

    private renderBody = () => {
        const {
            product: { description, isEdited, newDescription },
            isGridScrolling,
            access
        } = this.props;

        if (!access) {
            return <div>{description}</div>;
        }

        return (
            <>
                <EditableCell
                    isActive={isEdited}
                    onClick={this.toggleForm}
                    cls={Bem.cls(BLOCK, 'description')}
                >
                    {description}
                </EditableCell>
                <PopupDecorator
                    anchor={this}
                    visible={isEdited && !isGridScrolling}
                    target={'anchor'}
                    directions={DIRECTIONS}
                    hasTail={true}
                    header={i18n('description')}
                    footer={this.renderFooter()}
                    onOutsideClick={this.toggleForm}
                    cls={Bem.cls(BLOCK, 'popup')}
                >
                    <DirectFormInput
                        theme={'normal'}
                        size={'xs'}
                        text={newDescription}
                        cls={Bem.cls(BLOCK, 'textarea')}
                        inputType={InputFieldType.TEXTAREA}
                        valid={true}
                        onChange={this.onChangeDescription}
                    />
                </PopupDecorator>
            </>
        );
    };

    private renderFooter = () => {
        const {
            pageStatus,
            product: { description, newDescription }
        } = this.props;

        return (
            <div className={Bem.cls(BLOCK, 'actions')}>
                <ButtonDecorator
                    cls={Bem.cls(BLOCK, 'action')}
                    theme={'action'}
                    size={'s'}
                    text={i18n('save')}
                    onClick={this.onSaveDescription}
                    progress={pageStatus === ProductsPageStates.ACTION}
                    disabled={description === newDescription.trim()}
                />
                <ButtonDecorator
                    theme={'normal'}
                    size={'s'}
                    text={i18n('cancel')}
                    onClick={this.toggleForm}
                    disabled={pageStatus === ProductsPageStates.ACTION}
                />
            </div>
        );
    };

    private toggleForm = () => {
        const { onChangeProductDescription, product } = this.props;

        onChangeProductDescription({
            ...product,
            isEdited: !product.isEdited,
            newDescription: product.description
        });
    };

    private onChangeDescription = (newDescription: string) => {
        const { onChangeProductDescription, product } = this.props;

        onChangeProductDescription({ ...product, newDescription });
    };

    private onSaveDescription = () => {
        const { onSaveProductDescription, product } = this.props;

        onSaveProductDescription(product);
    };
}
